'use strict';

var React = require('react');
require('prop-types');
var Settings = require('../../node_modules/@material-ui/icons/Settings.js');
var Domain = require('../../node_modules/@material-ui/icons/Domain.js');
var ExitToApp = require('../../node_modules/@material-ui/icons/ExitToApp.js');
var HCAvatar = require('./HCAvatar.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var Popover = require('../../node_modules/@material-ui/core/esm/Popover/Popover.js');
var Grid = require('../../node_modules/@material-ui/core/esm/Grid/Grid.js');
var Typography = require('../../node_modules/@material-ui/core/esm/Typography/Typography.js');
var MenuItem = require('../../node_modules/@material-ui/core/esm/MenuItem/MenuItem.js');
var ListItemIcon = require('../../node_modules/@material-ui/core/esm/ListItemIcon/ListItemIcon.js');
var ListItemText = require('../../node_modules/@material-ui/core/esm/ListItemText/ListItemText.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    menuItem: {
      '&:focus': {
        backgroundColor: theme.palette.primary.main
      }
    },
    avatar: {
      margin: 10
    },
    profileRow: {
      paddingTop: 10,
      paddingBottom: 10,
      background: '#eeeeee'
    },
    profileNameAndEmailContainer: {
      paddingLeft: 10,
      paddingRight: 20
    }
  };
};

function AccountSettingPopover(_ref) {
  var classes = _ref.classes,
      open = _ref.open,
      anchorEl = _ref.anchorEl,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      email = _ref.email,
      avatarUrl = _ref.avatarUrl,
      showAccountSettings = _ref.showAccountSettings,
      showCompanySettings = _ref.showCompanySettings,
      showLogOut = _ref.showLogOut,
      onAccountSettingsClicked = _ref.onAccountSettingsClicked,
      onCompanySettingsClicked = _ref.onCompanySettingsClicked,
      onLogOut = _ref.onLogOut,
      onClose = _ref.onClose;
  return React__default["default"].createElement(Popover["default"], {
    id: "menu-appbar",
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    open: open,
    onClose: onClose
  }, React__default["default"].createElement(Grid["default"], {
    container: true,
    className: classes.profileRow
  }, React__default["default"].createElement(Grid["default"], {
    item: true,
    className: classes.avatar
  }, React__default["default"].createElement(HCAvatar, {
    avatarUrl: avatarUrl,
    firstName: firstName,
    lastName: lastName
  })), React__default["default"].createElement(Grid["default"], {
    item: true,
    container: true,
    xs: true,
    className: classes.profileNameAndEmailContainer
  }, React__default["default"].createElement(Grid["default"], {
    item: true,
    xs: 12
  }, React__default["default"].createElement(Typography["default"], {
    variant: "h6"
  }, "".concat(firstName, " ").concat(lastName))), React__default["default"].createElement(Grid["default"], {
    item: true,
    xs: 12
  }, React__default["default"].createElement(Typography["default"], null, email)))), showAccountSettings && React__default["default"].createElement(MenuItem["default"], {
    onClick: onAccountSettingsClicked
  }, React__default["default"].createElement(ListItemIcon["default"], null, React__default["default"].createElement(Settings, null)), React__default["default"].createElement(ListItemText["default"], {
    inset: true,
    primary: "Account settings"
  })), showCompanySettings && React__default["default"].createElement(MenuItem["default"], {
    onClick: onCompanySettingsClicked
  }, React__default["default"].createElement(ListItemIcon["default"], null, React__default["default"].createElement(Domain, null)), React__default["default"].createElement(ListItemText["default"], {
    inset: true,
    primary: "Company settings"
  })), showLogOut && React__default["default"].createElement(MenuItem["default"], {
    onClick: onLogOut
  }, React__default["default"].createElement(ListItemIcon["default"], null, React__default["default"].createElement(ExitToApp, null)), React__default["default"].createElement(ListItemText["default"], {
    inset: true,
    primary: "Sign out"
  })));
}

AccountSettingPopover.defaultProps = {
  open: false,
  avatarUrl: '',
  firstName: '',
  lastName: '',
  email: '',
  showAccountSettings: true,
  showCompanySettings: true,
  showLogOut: true,
  onAccountSettingsClicked: function onAccountSettingsClicked() {},
  onCompanySettingsClicked: function onCompanySettingsClicked() {},
  onLogOut: function onLogOut() {},
  onClose: function onClose() {}
};
var AccountSettingPopover$1 = withStyles(styles)(AccountSettingPopover);

module.exports = AccountSettingPopover$1;
